import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';
import LimitesModal from './modals/LimitesModal';
import AppareilsModal from './modals/AppareilsModal';

// === Listes alignées sur l'app principale (Etape3Conditions.jsx) ===

const FONCTIONS_COMMUNES = [
  "Responsable technique",
  "Chef d'entreprise",
  "Responsable maintenance",
  "Électricien",
  "Gérant",
  "Responsable",
  "Conducteur de travaux",
  "Chef de chantier",
  "Assistante",
  "Secrétaire",
  "Employé",
  "Agent",
  "Autre...",
];

const ORGANISMES_COMMUNS = [
  "Bureau Veritas",
  "SOCOTEC",
  "APAVE",
  "Qualiconsult",
  "Dekra",
  "SECOPREV",
  "Alpes Contrôle",
  "A2S PREVENTION",
  "Autre...",
];

const DELIMITATIONS = [
  { value: "complete", label: "Ensemble des installations accessibles et présentées" },
  { value: "partielle", label: "Installation partielle selon délimitation convenue" },
  { value: "specifique", label: "Délimitation spécifique (préciser)" },
];

const DELIMITATIONS_RVRAT = [
  { value: "complete", label: "Ensemble des installations modifiées et présentées" },
  { value: "partielle", label: "Installation partielle selon délimitation convenue" },
  { value: "specifique", label: "Délimitation spécifique (préciser)" },
];

const DOMAINES_TENSION = [
  { value: "BT", label: "Basse Tension" },
  { value: "HTA", label: "Haute Tension (HTA)" },
  { value: "BT_HTA", label: "Basse Tension et Haute Tension (HTA)" },
];

const REGISTRE_OPTIONS = [
  { value: "vise", label: "Visé à l'issue de la vérification" },
  { value: "non_vise", label: "Non visé" },
  { value: "absent", label: "Absent" },
];

// IMPORTANT : valeurs alignées sur l'app principale (labels longs).
// Pour la rétro-compat avec d'anciennes données PWA, on accepte aussi les anciens slugs
// via la fonction migrateModificationValue ci-dessous.
const MODIFICATIONS_OPTIONS = [
  { value: "Sans objet s'agissant d'une première vérification", label: "Sans objet s'agissant d'une première vérification" },
  { value: "Aucune modification de structure ne nous a été signalée", label: "Aucune modification de structure ne nous a été signalée" },
  { value: "Installations concernées par la modification de structure", label: "Installations concernées par la modification de structure" },
];

const TYPES_RAPPORT_REF = [
  "Rapport de Vérification périodique",
  "Rapport de vérification initiale",
  "Rapport de vérification quadriennale",
];

// Mappe les anciens slugs PWA vers les nouveaux labels longs (compat ascendante)
const migrateModificationValue = (val) => {
  if (val === 'sans_objet_premiere') return "Sans objet s'agissant d'une première vérification";
  if (val === 'aucune_modification') return "Aucune modification de structure ne nous a été signalée";
  if (val === 'modifications') return "Installations concernées par la modification de structure";
  return val || '';
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
    paddingBottom: '100px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  headerTemporaire: { background: 'linear-gradient(135deg, #f59e0b, #d97706)' },
  headerRVRAT: { background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)' },
  badgeRVRAT: {
    margin: '16px 20px',
    padding: '12px 16px',
    background: 'linear-gradient(135deg, #ede9fe, #ddd6fe)',
    border: '2px solid #8b5cf6',
    borderRadius: '12px',
    color: '#5b21b6',
    fontWeight: '600',
    textAlign: 'center',
    fontSize: '13px',
  },
  headerTitle: { fontSize: '18px', fontWeight: '700', margin: 0 },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  saveBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '18px',
    cursor: 'pointer',
  },
  badge: {
    margin: '16px 20px',
    padding: '12px 16px',
    background: 'linear-gradient(135deg, #fef3c7, #fde68a)',
    border: '2px solid #f59e0b',
    borderRadius: '12px',
    color: '#92400e',
    fontWeight: '600',
    textAlign: 'center',
    fontSize: '13px',
  },
  content: { padding: '0 20px' },
  card: {
    background: 'white',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  fieldGroup: { marginBottom: '20px' },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#334155',
    marginBottom: '8px',
  },
  required: { color: '#ef4444', marginLeft: '4px' },
  select: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '15px',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    background: 'white',
    color: '#334155',
    appearance: 'none',
    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
    backgroundPosition: 'right 12px center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '20px',
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '15px',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    background: 'white',
    color: '#334155',
    boxSizing: 'border-box',
  },
  textarea: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '15px',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    background: 'white',
    color: '#334155',
    minHeight: '100px',
    resize: 'vertical',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  radioGroup: { display: 'flex', flexDirection: 'column', gap: '12px' },
  radioOption: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '16px',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  radioOptionSelected: { border: '2px solid #3b82f6', background: '#eff6ff' },
  radioInput: {
    width: '20px',
    height: '20px',
    marginTop: '2px',
    accentColor: '#3b82f6',
  },
  radioContent: { flex: 1 },
  radioTitle: { fontSize: '15px', fontWeight: '600', color: '#1e293b', marginBottom: '4px' },
  radioDesc: { fontSize: '13px', color: '#64748b' },
  accompagnementBox: {
    padding: '16px',
    background: '#f0fdf4',
    borderLeft: '4px solid #22c55e',
    borderRadius: '0 12px 12px 0',
    marginTop: '16px',
  },
  copyBtn: {
    background: '#eff6ff',
    border: '1px solid #3b82f6',
    color: '#1e40af',
    padding: '6px 12px',
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  },
  rapportRefHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
    paddingTop: '16px',
    borderTop: '1px solid #e2e8f0',
  },
  rapportRefTitle: { fontSize: '15px', fontWeight: '700', color: '#0f172a' },
  checkboxRow: { display: 'flex', alignItems: 'center', gap: '8px' },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)',
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #10b981, #059669)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer',
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: '#f8fafc',
  },
};

/**
 * Sélecteur de fonction réutilisable, avec champ "Autre..." conditionnel.
 * Aligné sur l'app principale.
 */
function FonctionSelectField({ value, autreValue, onChange, onAutreChange, placeholder = 'Sélectionner...' }) {
  return (
    <>
      <select
        style={styles.select}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">{placeholder}</option>
        {FONCTIONS_COMMUNES.map((f) => (
          <option key={f} value={f}>{f}</option>
        ))}
      </select>
      {value === 'Autre...' && (
        <input
          type="text"
          style={{ ...styles.input, marginTop: '8px' }}
          value={autreValue || ''}
          onChange={(e) => onAutreChange(e.target.value)}
          placeholder="Préciser la fonction"
        />
      )}
    </>
  );
}

function Etape3({ mission, onBack, onSave }) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [typeVerification, setTypeVerification] = useState('');
  const [typeRapportTemporaire, setTypeRapportTemporaire] = useState('');
  const [showLimitesModal, setShowLimitesModal] = useState(false);
  const [showAppareilsModal, setShowAppareilsModal] = useState(false);
  const [missionMeta, setMissionMeta] = useState(null);

  // Détection du type de rapport (logique inchangée)
  const isTemporaire =
    typeVerification?.includes('temporaire') ||
    typeVerification?.includes('R4226-21') ||
    typeVerification === 'Installation temporaire (R4226-21)';
  const isTemporaireSimplifie = isTemporaire && typeRapportTemporaire === 'simplifie';

  const isRVRAT =
    typeVerification === 'Vérification après travaux ERP 1er groupe (RVRAT)' ||
    typeVerification?.includes('RVRAT');

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mission.id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const savedData = await inspectionStorage.getStep(mission.id, 'etape_3_conditions');
      if (savedData) {
        // Migration douce des anciens slugs sur modification_installations
        const migrated = {
          ...savedData,
          modification_installations: migrateModificationValue(savedData.modification_installations),
        };
        setData(migrated);
      }

      const meta = await inspectionStorage.getStep(mission.id, 'meta');
      if (meta) setMissionMeta(meta);

      const etape1Data = await inspectionStorage.getStep(mission.id, 'etape_1_infos_generales');
      if (etape1Data) {
        setTypeVerification(etape1Data.type_verification || mission.type_verification || '');
        setTypeRapportTemporaire(etape1Data.type_rapport_temporaire || '');
      } else {
        setTypeVerification(mission.type_verification || '');
      }
    } catch (error) {
      console.error('❌ Erreur chargement:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setData((prev) => ({ ...prev, [field]: value }));
  };

  // P3 : copie de la personne surveillance vers accompagnement + compte rendu
  const handleCopyPersonne = () => {
    setData((prev) => ({
      ...prev,
      accompagnement_verificateur: prev.personne_surveillance || '',
      accompagnement_fonction: prev.personne_surveillance_fonction || '',
      accompagnement_fonction_autre: prev.personne_surveillance_fonction_autre || '',
      compte_rendu_a: prev.personne_surveillance || '',
      compte_rendu_fonction: prev.personne_surveillance_fonction || '',
      compte_rendu_fonction_autre: prev.personne_surveillance_fonction_autre || '',
    }));
  };

  const handleToggleSansObjet = (checked) => {
    setData((prev) => ({
      ...prev,
      rapport_ref_sans_objet: checked,
      ...(checked
        ? {
            type_rapport_ref: '',
            date_rapport_ref: '',
            numero_rapport_ref: '',
            organisme_ref: '',
            organisme_ref_autre: '',
          }
        : {}),
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await inspectionStorage.saveStep(mission.id, 'etape_3_conditions', data);
      console.log('✅ Étape 3 sauvegardée');
      if (onSave) onSave(data);
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={styles.loading}>
        <div
          style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e2e8f0',
            borderTopColor: '#3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        ></div>
        <p style={{ marginTop: '16px', color: '#64748b', fontWeight: '500' }}>Chargement...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  // ============================================================
  // VERSION RVRAT — alignée sur l'app principale
  // ============================================================
  if (isRVRAT) {
    return (
      <div style={styles.container}>
        <div style={{ ...styles.header, ...styles.headerRVRAT }}>
          <button style={styles.backBtn} onClick={onBack}>← Retour</button>
          <h1 style={styles.headerTitle}>Conditions (RVRAT)</h1>
          <button style={styles.saveBtn} onClick={handleSave} disabled={saving}>
            {saving ? '⏳' : '💾'}
          </button>
        </div>

        <div style={styles.badgeRVRAT}>
          🏛️ Rapport RVRAT - ERP 1er groupe
          <br />
          <span style={{ fontSize: '12px', fontWeight: '400' }}>Vérification après travaux</span>
        </div>

        <div style={styles.content}>
          <div style={styles.card}>
            {/* Objet de la vérification */}
            <div style={styles.fieldGroup}>
              <label style={styles.label}>
                Objet de la vérification<span style={styles.required}>*</span>
              </label>
              <textarea
                style={styles.textarea}
                value={data.objet_verification || ''}
                onChange={(e) => handleChange('objet_verification', e.target.value)}
                placeholder="Préciser l'objet de la vérification (travaux réalisés, modifications, extensions...)"
              />
              <p style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>
                Ex: Vérification après extension de l'installation électrique, création de nouveaux circuits, etc.
              </p>
            </div>

            {/* Nature des travaux */}
            <div style={styles.fieldGroup}>
              <label style={styles.label}>
                Nature des travaux réalisés<span style={styles.required}>*</span>
              </label>
              <textarea
                style={styles.textarea}
                value={data.nature_travaux || ''}
                onChange={(e) => handleChange('nature_travaux', e.target.value)}
                placeholder="Décrire précisément les travaux électriques réalisés..."
              />
            </div>

            {/* Délimitation de la vérification */}
            <div style={styles.fieldGroup}>
              <label style={styles.label}>
                Délimitation de la vérification<span style={styles.required}>*</span>
              </label>
              <select
                style={styles.select}
                value={data.delimitation_verification || ''}
                onChange={(e) => handleChange('delimitation_verification', e.target.value)}
              >
                <option value="">Sélectionner la délimitation</option>
                {DELIMITATIONS_RVRAT.map((d) => (
                  <option key={d.value} value={d.value}>{d.label}</option>
                ))}
              </select>

              {data.delimitation_verification === 'specifique' && (
                <textarea
                  style={{ ...styles.textarea, marginTop: '12px' }}
                  value={data.delimitation_specifique || ''}
                  onChange={(e) => handleChange('delimitation_specifique', e.target.value)}
                  placeholder="Préciser la délimitation spécifique..."
                />
              )}
            </div>

            {/* Type d'accompagnement (radio) — aligné sur l'app */}
            <div style={styles.fieldGroup}>
              <label style={styles.label}>
                Type d'accompagnement<span style={styles.required}>*</span>
              </label>
              <div style={styles.radioGroup}>
                <div
                  style={{
                    ...styles.radioOption,
                    ...((data.type_accompagnement || 'avec') === 'avec' ? styles.radioOptionSelected : {}),
                  }}
                  onClick={() => handleChange('type_accompagnement', 'avec')}
                >
                  <input
                    type="radio"
                    style={styles.radioInput}
                    checked={(data.type_accompagnement || 'avec') === 'avec'}
                    onChange={() => handleChange('type_accompagnement', 'avec')}
                  />
                  <div style={styles.radioContent}>
                    <div style={styles.radioTitle}>Avec accompagnement</div>
                    <div style={styles.radioDesc}>
                      Le vérificateur a été accompagné par une personne désignée
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    ...styles.radioOption,
                    ...(data.type_accompagnement === 'sans' ? styles.radioOptionSelected : {}),
                  }}
                  onClick={() => handleChange('type_accompagnement', 'sans')}
                >
                  <input
                    type="radio"
                    style={styles.radioInput}
                    checked={data.type_accompagnement === 'sans'}
                    onChange={() => handleChange('type_accompagnement', 'sans')}
                  />
                  <div style={styles.radioContent}>
                    <div style={styles.radioTitle}>Sans accompagnement</div>
                    <div style={styles.radioDesc}>Le vérificateur a opéré seul</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Personne ayant accompagné (conditionné par type_accompagnement === 'avec') */}
            {(data.type_accompagnement || 'avec') === 'avec' && (
              <div style={styles.accompagnementBox}>
                <div style={styles.fieldGroup}>
                  <label style={styles.label}>
                    Personne ayant accompagné le vérificateur<span style={styles.required}>*</span>
                  </label>
                  <input
                    type="text"
                    style={styles.input}
                    value={data.accompagnement_verificateur || ''}
                    onChange={(e) => handleChange('accompagnement_verificateur', e.target.value)}
                    placeholder="Nom de la personne"
                  />
                </div>
                <div style={{ ...styles.fieldGroup, marginBottom: 0 }}>
                  <label style={styles.label}>Fonction</label>
                  <FonctionSelectField
                    value={data.accompagnement_fonction}
                    autreValue={data.accompagnement_fonction_autre}
                    onChange={(v) => handleChange('accompagnement_fonction', v)}
                    onAutreChange={(v) => handleChange('accompagnement_fonction_autre', v)}
                  />
                </div>
              </div>
            )}

            {/* Conditions d'examen — aligné sur l'app */}
            <div style={{ ...styles.fieldGroup, marginTop: '20px', marginBottom: 0 }}>
              <label style={styles.label}>Conditions d'examen</label>
              <textarea
                style={styles.textarea}
                value={data.conditions_examen || ''}
                onChange={(e) => handleChange('conditions_examen', e.target.value)}
                placeholder="Conditions particulières lors de l'examen (installations sous tension, locaux accessibles, éclairage, etc.)"
              />
            </div>
          </div>
        </div>

        <div style={styles.saveSection}>
          <button
            style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }}
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
          </button>
        </div>
      </div>
    );
  }

  // ============================================================
  // VERSION SIMPLIFIÉE pour installations temporaires
  // ============================================================
  if (isTemporaireSimplifie) {
    return (
      <div style={styles.container}>
        <div style={{ ...styles.header, ...styles.headerTemporaire }}>
          <button style={styles.backBtn} onClick={onBack}>← Retour</button>
          <h1 style={styles.headerTitle}>Conditions (Simplifié)</h1>
          <button style={styles.saveBtn} onClick={handleSave} disabled={saving}>
            {saving ? '⏳' : '💾'}
          </button>
        </div>

        <div style={styles.badge}>
          ⚡ Version simplifiée pour installations temporaires
          <br />
          <span style={{ fontSize: '12px', fontWeight: '400' }}>Seuls les champs essentiels sont requis</span>
        </div>

        <div style={styles.content}>
          <div style={styles.card}>
            {/* Délimitation */}
            <div style={styles.fieldGroup}>
              <label style={styles.label}>
                Délimitation de la vérification<span style={styles.required}>*</span>
              </label>
              <select
                style={styles.select}
                value={data.delimitation_verification || ''}
                onChange={(e) => handleChange('delimitation_verification', e.target.value)}
              >
                <option value="">Sélectionner la délimitation</option>
                {DELIMITATIONS.map((d) => (
                  <option key={d.value} value={d.value}>{d.label}</option>
                ))}
              </select>

              {data.delimitation_verification === 'specifique' && (
                <textarea
                  style={{ ...styles.textarea, marginTop: '12px' }}
                  value={data.delimitation_specifique || ''}
                  onChange={(e) => handleChange('delimitation_specifique', e.target.value)}
                  placeholder="Préciser la délimitation spécifique..."
                />
              )}
            </div>

            {/* Domaine de tension */}
            <div style={styles.fieldGroup}>
              <label style={styles.label}>
                Domaine de Tension<span style={styles.required}>*</span>
              </label>
              <select
                style={styles.select}
                value={data.domaine_tension || ''}
                onChange={(e) => handleChange('domaine_tension', e.target.value)}
              >
                <option value="">Sélectionner le domaine</option>
                {DOMAINES_TENSION.map((d) => (
                  <option key={d.value} value={d.value}>{d.label}</option>
                ))}
              </select>
            </div>

            {/* Type d'accompagnement (radio) */}
            <div style={styles.fieldGroup}>
              <label style={styles.label}>
                Type d'accompagnement<span style={styles.required}>*</span>
              </label>
              <div style={styles.radioGroup}>
                <div
                  style={{
                    ...styles.radioOption,
                    ...((data.type_accompagnement || 'avec') === 'avec' ? styles.radioOptionSelected : {}),
                  }}
                  onClick={() => handleChange('type_accompagnement', 'avec')}
                >
                  <input
                    type="radio"
                    style={styles.radioInput}
                    checked={(data.type_accompagnement || 'avec') === 'avec'}
                    onChange={() => handleChange('type_accompagnement', 'avec')}
                  />
                  <div style={styles.radioContent}>
                    <div style={styles.radioTitle}>Avec accompagnement</div>
                    <div style={styles.radioDesc}>Le vérificateur a été accompagné par une personne désignée</div>
                  </div>
                </div>
                <div
                  style={{
                    ...styles.radioOption,
                    ...(data.type_accompagnement === 'sans' ? styles.radioOptionSelected : {}),
                  }}
                  onClick={() => handleChange('type_accompagnement', 'sans')}
                >
                  <input
                    type="radio"
                    style={styles.radioInput}
                    checked={data.type_accompagnement === 'sans'}
                    onChange={() => handleChange('type_accompagnement', 'sans')}
                  />
                  <div style={styles.radioContent}>
                    <div style={styles.radioTitle}>Sans accompagnement</div>
                    <div style={styles.radioDesc}>Le vérificateur a opéré seul</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Personne ayant accompagné (conditionné) */}
            {(data.type_accompagnement || 'avec') === 'avec' && (
              <div style={styles.accompagnementBox}>
                <div style={styles.fieldGroup}>
                  <label style={styles.label}>
                    Personne ayant accompagné le vérificateur<span style={styles.required}>*</span>
                  </label>
                  <input
                    type="text"
                    style={styles.input}
                    value={data.accompagnement_verificateur || ''}
                    onChange={(e) => handleChange('accompagnement_verificateur', e.target.value)}
                    placeholder="Nom de la personne"
                  />
                </div>
                <div style={{ ...styles.fieldGroup, marginBottom: 0 }}>
                  <label style={styles.label}>Fonction</label>
                  <FonctionSelectField
                    value={data.accompagnement_fonction}
                    autreValue={data.accompagnement_fonction_autre}
                    onChange={(v) => handleChange('accompagnement_fonction', v)}
                    onAutreChange={(v) => handleChange('accompagnement_fonction_autre', v)}
                  />
                </div>
              </div>
            )}

            {/* Registre de sécurité */}
            <div style={{ ...styles.fieldGroup, marginTop: '20px', marginBottom: 0 }}>
              <label style={styles.label}>Registre de sécurité</label>
              <select
                style={styles.select}
                value={data.registre_securite || ''}
                onChange={(e) => handleChange('registre_securite', e.target.value)}
              >
                <option value="">Sélectionner</option>
                {REGISTRE_OPTIONS.map((r) => (
                  <option key={r.value} value={r.value}>{r.label}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div style={styles.saveSection}>
          <button
            style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }}
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
          </button>
        </div>
      </div>
    );
  }

  // ============================================================
  // VERSION COMPLÈTE pour les rapports classiques
  // ============================================================
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Conditions</h1>
        <button style={styles.saveBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      <div style={styles.content}>
        {/* Boutons Limites + Appareils (alignés avec l'app) */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '16px', marginTop: '16px' }}>
          <button
            type="button"
            onClick={() => setShowLimitesModal(true)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 16px',
              background: 'linear-gradient(135deg, #fef3c7, #fde68a)',
              border: '2px solid #f59e0b',
              borderRadius: '12px',
              color: '#92400e',
              fontWeight: '600',
              fontSize: '14px',
              cursor: 'pointer',
              boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
            }}
          >
            🛡️ Limites d'interventions et conditions de mise hors tension
          </button>
          <button
            type="button"
            onClick={() => setShowAppareilsModal(true)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 16px',
              background: 'white',
              border: '2px solid #e2e8f0',
              borderRadius: '12px',
              color: '#334155',
              fontWeight: '600',
              fontSize: '14px',
              cursor: 'pointer',
              boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
            }}
          >
            🔧 Appareils de mesure utilisés
          </button>
        </div>

        <div style={styles.card}>
          {/* Délimitation */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              Délimitation de la vérification<span style={styles.required}>*</span>
            </label>
            <select
              style={styles.select}
              value={data.delimitation_verification || ''}
              onChange={(e) => handleChange('delimitation_verification', e.target.value)}
            >
              <option value="">Sélectionner la délimitation</option>
              {DELIMITATIONS.map((d) => (
                <option key={d.value} value={d.value}>{d.label}</option>
              ))}
            </select>

            {data.delimitation_verification === 'specifique' && (
              <textarea
                style={{ ...styles.textarea, marginTop: '12px' }}
                value={data.delimitation_specifique || ''}
                onChange={(e) => handleChange('delimitation_specifique', e.target.value)}
                placeholder="Préciser la délimitation spécifique..."
              />
            )}
          </div>

          {/* Domaine de tension */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              Domaine de Tension<span style={styles.required}>*</span>
            </label>
            <select
              style={styles.select}
              value={data.domaine_tension || ''}
              onChange={(e) => handleChange('domaine_tension', e.target.value)}
            >
              <option value="">Sélectionner le domaine</option>
              {DOMAINES_TENSION.map((d) => (
                <option key={d.value} value={d.value}>{d.label}</option>
              ))}
            </select>
          </div>

          {/* Personne chargée de la surveillance + bouton Copier (P3) */}
          <div style={styles.fieldGroup}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '8px',
              }}
            >
              <label style={{ ...styles.label, marginBottom: 0 }}>
                Personne chargée de la surveillance des installations<span style={styles.required}>*</span>
              </label>
              <button type="button" style={styles.copyBtn} onClick={handleCopyPersonne}>
                📋 Copier
              </button>
            </div>
            <input
              type="text"
              style={styles.input}
              value={data.personne_surveillance || ''}
              onChange={(e) => handleChange('personne_surveillance', e.target.value)}
              placeholder="Nom de la personne"
            />
            <div style={{ marginTop: '8px' }}>
              <FonctionSelectField
                value={data.personne_surveillance_fonction}
                autreValue={data.personne_surveillance_fonction_autre}
                onChange={(v) => handleChange('personne_surveillance_fonction', v)}
                onAutreChange={(v) => handleChange('personne_surveillance_fonction_autre', v)}
                placeholder="Fonction..."
              />
            </div>
            <p style={{ fontSize: '11px', color: '#64748b', marginTop: '4px' }}>
              💡 Le bouton « Copier » duplique nom + fonction vers les blocs Accompagnement et Compte rendu.
            </p>
          </div>

          {/* Personne ayant accompagné */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              Personne ayant accompagné le vérificateur<span style={styles.required}>*</span>
            </label>
            <input
              type="text"
              style={styles.input}
              value={data.accompagnement_verificateur || ''}
              onChange={(e) => handleChange('accompagnement_verificateur', e.target.value)}
              placeholder="Nom de la personne"
            />
            <div style={{ marginTop: '8px' }}>
              <FonctionSelectField
                value={data.accompagnement_fonction}
                autreValue={data.accompagnement_fonction_autre}
                onChange={(v) => handleChange('accompagnement_fonction', v)}
                onAutreChange={(v) => handleChange('accompagnement_fonction_autre', v)}
                placeholder="Fonction..."
              />
            </div>
          </div>

          {/* Compte rendu oral */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              Compte rendu oral fin de visite à<span style={styles.required}>*</span>
            </label>
            <input
              type="text"
              style={styles.input}
              value={data.compte_rendu_a || ''}
              onChange={(e) => handleChange('compte_rendu_a', e.target.value)}
              placeholder="Nom de la personne"
            />
            <div style={{ marginTop: '8px' }}>
              <FonctionSelectField
                value={data.compte_rendu_fonction}
                autreValue={data.compte_rendu_fonction_autre}
                onChange={(v) => handleChange('compte_rendu_fonction', v)}
                onAutreChange={(v) => handleChange('compte_rendu_fonction_autre', v)}
                placeholder="Fonction..."
              />
            </div>
          </div>

          {/* Registre de sécurité */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>Registre de sécurité</label>
            <select
              style={styles.select}
              value={data.registre_securite || ''}
              onChange={(e) => handleChange('registre_securite', e.target.value)}
            >
              <option value="">Sélectionner</option>
              {REGISTRE_OPTIONS.map((r) => (
                <option key={r.value} value={r.value}>{r.label}</option>
              ))}
            </select>
          </div>

          {/* Modifications de structure (valeurs alignées sur l'app) */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>Modifications de structure de l'installation électrique</label>
            <select
              style={styles.select}
              value={data.modification_installations || ''}
              onChange={(e) => handleChange('modification_installations', e.target.value)}
            >
              <option value="">-- Sélectionner --</option>
              {MODIFICATIONS_OPTIONS.map((m) => (
                <option key={m.value} value={m.value}>{m.label}</option>
              ))}
            </select>
            {data.modification_installations === 'Installations concernées par la modification de structure' && (
              <textarea
                style={{ ...styles.textarea, marginTop: '12px' }}
                value={data.modification_details || ''}
                onChange={(e) => handleChange('modification_details', e.target.value)}
                placeholder="Décrire les modifications..."
              />
            )}
          </div>

          {/* Section "Rapport de Vérification de référence" (P1, alignée sur l'app) */}
          <div style={styles.rapportRefHeader}>
            <h3 style={styles.rapportRefTitle}>Rapport de Vérification de référence</h3>
            <label style={styles.checkboxRow}>
              <input
                type="checkbox"
                checked={data.rapport_ref_sans_objet || false}
                onChange={(e) => handleToggleSansObjet(e.target.checked)}
                style={{ width: '18px', height: '18px', accentColor: '#3b82f6' }}
              />
              <span style={{ fontSize: '13px', fontWeight: '500', color: '#334155' }}>
                Sans Objet (aucun rapport présenté)
              </span>
            </label>
          </div>

          {!data.rapport_ref_sans_objet && (
            <>
              <div style={styles.fieldGroup}>
                <label style={styles.label}>Type de rapport</label>
                <select
                  style={styles.select}
                  value={data.type_rapport_ref || ''}
                  onChange={(e) => handleChange('type_rapport_ref', e.target.value)}
                >
                  <option value="">Type</option>
                  {TYPES_RAPPORT_REF.map((t) => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
              </div>

              <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                <div style={{ ...styles.fieldGroup, flex: 1, minWidth: '140px' }}>
                  <label style={styles.label}>Date</label>
                  <input
                    type="date"
                    style={styles.input}
                    value={data.date_rapport_ref || ''}
                    onChange={(e) => handleChange('date_rapport_ref', e.target.value)}
                  />
                </div>

                <div style={{ ...styles.fieldGroup, flex: 1, minWidth: '140px' }}>
                  <label style={styles.label}>Numéro de rapport</label>
                  <input
                    type="text"
                    style={styles.input}
                    value={data.numero_rapport_ref || ''}
                    onChange={(e) => handleChange('numero_rapport_ref', e.target.value)}
                    placeholder="N° rapport"
                  />
                </div>
              </div>

              <div style={{ ...styles.fieldGroup, marginBottom: 0 }}>
                <label style={styles.label}>Organisme</label>
                <select
                  style={styles.select}
                  value={data.organisme_ref || ''}
                  onChange={(e) => handleChange('organisme_ref', e.target.value)}
                >
                  <option value="">Nom de l'organisme</option>
                  {ORGANISMES_COMMUNS.map((o) => (
                    <option key={o} value={o}>{o}</option>
                  ))}
                </select>
                {data.organisme_ref === 'Autre...' && (
                  <input
                    type="text"
                    style={{ ...styles.input, marginTop: '8px' }}
                    value={data.organisme_ref_autre || ''}
                    onChange={(e) => handleChange('organisme_ref_autre', e.target.value)}
                    placeholder="Préciser l'organisme"
                  />
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Modals */}
      <LimitesModal
        isOpen={showLimitesModal}
        onClose={() => setShowLimitesModal(false)}
        data={data}
        onSave={(formData) => {
          setData((prev) => ({ ...prev, ...formData }));
          setShowLimitesModal(false);
        }}
      />
      <AppareilsModal
        isOpen={showAppareilsModal}
        onClose={() => setShowAppareilsModal(false)}
        data={data}
        onSave={(payload) => {
          setData((prev) => ({ ...prev, ...payload }));
          setShowAppareilsModal(false);
        }}
        mission={mission}
        missionMeta={missionMeta}
      />

      <div style={styles.saveSection}>
        <button
          style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }}
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>
    </div>
  );
}

export default Etape3;
